import { render, staticRenderFns } from "./registrationGift.vue?vue&type=template&id=5fb37dba"
import script from "./registrationGift.vue?vue&type=script&lang=js"
export * from "./registrationGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports